import React, { useState, useEffect } from "react";
import "./Navbar.css";
import Logo from "../Assets/Logo/Adson.jpg"
import useActiveSection from "../../hooks/useActiveSection";

const LINKS = [
  { href: "#home", label: "Home" },
  { href: "#services", label: "Services" },
  { href: "#portfolio", label: "Portfolio" },
  { href: "#about", label: "About" },
  { href: "#company", label: "Company Profile" },
  { href: "#contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const sectionIds = LINKS.map((l) => l.href.replace("#", ""));
  const activeId = useActiveSection(sectionIds);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 992) setOpen(false);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const handleNavClick = (e, href) => {
    e.preventDefault();
    const id = href.replace("#", "");
    const el = document.getElementById(id);
    if (!el) return;

    const NAV_HEIGHT = 72; // adjust to your real navbar height
    const top = el.getBoundingClientRect().top + window.pageYOffset - NAV_HEIGHT;

    window.scrollTo({ top, behavior: "smooth" });
    setOpen(false);
  };

  return (
    <header className={`nav ${scrolled ? "nav--scrolled" : ""}`}>
      <div className="nav__inner">
        <a href="#home" className="nav__brand">
          {/* <span className="nav__brand-accent">SR</span> Ads Agency */}
          <img src={Logo} alt="SR Ads Agency Logo" className="nav__logo" />
        </a>

        <button
          className={`nav__toggle ${open ? "is-open" : ""}`}
          onClick={() => setOpen((o) => !o)}
          aria-label="Toggle menu"
          aria-expanded={open}
          aria-controls="primary-navigation"
        >
          <span />
          <span />
          <span />
        </button>

        <nav
          id="primary-navigation"
          className={`nav__links ${open ? "is-open" : ""}`}
        >
          {LINKS.map((l) => {
          const id = l.href.replace("#", "");
          const isActive = activeId === id;
          return (
            <a
              key={l.href}
              href={l.href}
              className={isActive ? "is-active" : ""}
              onClick={(e) => handleNavClick(e, l.href)}
            >
              {l.label}
            </a>
          );
          })}

          <a
            href="https://wa.me/971586567055"
            target="_blank"
            rel="noreferrer"
            className="nav__cta"
            onClick={() => setOpen(false)}
          >
            Request a Quote
          </a>
        </nav>
      </div>
    </header>
  );
}
